//Cesium3DTileset设置光带特效

export function opticalBand() {
    const customShader = new Cesium.CustomShader({
        lightingModel: Cesium.LightingModel.UNLIT,
        fragmentShaderText: `
            void fragmentMain(FragmentInput fsInput, inout czm_modelMaterial material) {
                float _baseHeight = 0.0; // 物体的基础高度，需要修改成一个合适的建筑基础高度
                float _heightRange = 60.0; // 高亮的范围(_baseHeight ~ _baseHeight + _heightRange) 默认是 0-60米
                float _glowRange = 300.0; // 光环的移动范围(高度)
                float vtxf_height = fsInput.attributes.positionMC.z-_baseHeight;
                float vtxf_a11 = fract(czm_frameNumber / 120.0) * 3.14159265 * 2.0;
                float vtxf_a12 = vtxf_height / _heightRange + sin(vtxf_a11) * 0.1;
                material.diffuse*= vec3(vtxf_a12, vtxf_a12, vtxf_a12);
                float vtxf_a13 = fract(czm_frameNumber / 360.0);
                float vtxf_h = clamp(vtxf_height / _glowRange, 0.0, 1.0);
                vtxf_a13 = abs(vtxf_a13 - 0.5) * 2.0;
                float vtxf_diff = step(0.005, abs(vtxf_h - vtxf_a13));
                material.diffuse += material.diffuse * (1.0 - vtxf_diff);
            }    
        `,
    });

    // Applying to all tiles in a tileset.
    const tilesets = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        url: "//data.mars3d.cn/3dtiles/jzw-hefei/tileset.json",
        customShader: customShader
    }));

    tilesets.readyPromise.then(function (tileset) {
        viewer.flyTo(tileset);
    });
}


//模型局部光源
export function lightModel() {
    const customShader = new Cesium.CustomShader({
        lightingModel: Cesium.LightingModel.UNLIT,
        uniforms: {
            u_cameraDirectionWC: {
                type: Cesium.UniformType.VEC3,
                value: viewer.scene.camera.positionWC,
            },
            u_lightColor1: {
                type: Cesium.UniformType.VEC4,
                value: new Cesium.Color(1.0, 0.0, 0.0, 1.0),
            },
            u_lightPos1: {
                type: Cesium.UniformType.VEC3,
                value: Cesium.Cartesian3.fromDegrees(117.24594257, 31.82942758, 300),
            },
            u_lightColor2: {
                type: Cesium.UniformType.VEC4,
                value: new Cesium.Color(0.0, 0.0, 1.0, 1.0),
            },
            u_lightPos2: {
                type: Cesium.UniformType.VEC3,
                value: Cesium.Cartesian3.fromDegrees(117.25594257, 31.82942758, 300),
            },
            u_lightColor3: {
                type: Cesium.UniformType.VEC4,
                value: new Cesium.Color(0.0, 1.0, 1.0, 1.0),
            },
            u_lightPos3: {
                type: Cesium.UniformType.VEC3,
                value: Cesium.Cartesian3.fromDegrees(117.26594257, 31.82942758, 300),
            },
        },
        fragmentShaderText: `
            vec4 makeLight(vec4 lightColorHdr,vec3 lightPos,
              vec3 positionWC,vec3 positionEC,vec3 normalEC,czm_pbrParameters pbrParameters)
            {
              vec3 color = vec3(0.0);
              float mx1 = 1.0;
              vec3 light1Dir = positionWC - lightPos;
              float distance1 = length(light1Dir);
              if(distance1 < 1000.0){
                vec4 l1 = czm_view * vec4(lightPos, 1.0);
                vec3 lightDirectionEC = l1.xyz - positionEC;
                mx1 = 1.0 - distance1 / 1000.0;
                color = czm_pbrLighting(
                  positionEC,
                  normalEC,
                  lightDirectionEC,
                  lightColorHdr.xyz,
                  pbrParameters
                ).xyz;
              }
              mx1 = max(color.r,max(color.g,color.b)) * pow(mx1,1.0) * 10.0;
              return vec4(color,mx1);
            }
            void fragmentMain(FragmentInput fsInput, inout czm_modelMaterial material)
            {
              material.diffuse = vec3(1.0);
              vec3 positionWC = fsInput.attributes.positionWC;
              vec3 normalEC = fsInput.attributes.normalEC;
              vec3 positionEC = fsInput.attributes.positionEC;
    
              vec3 lightColorHdr = czm_lightColorHdr;
              vec3 lightDirectionEC = czm_lightDirectionEC;
              lightDirectionEC = (czm_view * vec4(u_cameraDirectionWC,1.0)).xyz - positionEC;
    
              czm_pbrParameters pbrParameters;
              pbrParameters.diffuseColor = material.diffuse;
              pbrParameters.f0 = vec3(0.5);
              pbrParameters.roughness = 1.0;
    
              vec3 ligth1Color0 = czm_pbrLighting(
                positionEC,
                normalEC,
                lightDirectionEC,
                lightColorHdr,
                pbrParameters
              );
    
              vec4 ligth1ColorR = makeLight(u_lightColor1,u_lightPos1,positionWC,positionEC,normalEC,pbrParameters);
              vec4 ligth1ColorG = makeLight(u_lightColor2,u_lightPos2,positionWC,positionEC,normalEC,pbrParameters);
              vec4 ligth1ColorB = makeLight(u_lightColor3,u_lightPos3,positionWC,positionEC,normalEC,pbrParameters);
    
              vec3 finalColor = mix(ligth1Color0.rgb, ligth1ColorR.rgb, ligth1ColorR.a);
              finalColor = mix(finalColor, ligth1ColorG.rgb, ligth1ColorG.a);
              finalColor = mix(finalColor, ligth1ColorB.rgb, ligth1ColorB.a);
              material.diffuse = finalColor;
            }
            `,
    });


    // Applying to all tiles in a tileset.
    const tilesets = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        url: "//data.mars3d.cn/3dtiles/jzw-hefei/tileset.json",
        customShader: customShader
    }));

    tilesets.readyPromise.then(function (tileset) {
        viewer.flyTo(tileset);
    });

}